export default ({ index }) => `
    <style>
        [data-odr-widget="${index}"] {
            --odr-input-padding-arrow: 0 13px 0 5px !important;
            --odr-input-padding: 0 0 0 5px !important;
            --odr-input-minWidth: 120px !important;
        }
    </style>
    <span data-odr-container="${index}"></span>`;
